import { Header } from '@assets/component/Header/Header';
import { StorageUpload } from '@assets/component/StorageUpload/StorageUpload';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view';
import Box from '@mui/material/Box';
const KnowledgeBase = observer(() => {
    const store = useStore();

    return (
        <>
            <div
                className="d-flex justify-content-center"
                style={{ height: '100%' }}
            >
                <Flex direction="column" className="h-100 w-100">
                    <Header disableTicker={true} showNewDeal={true} />
                    <Box sx={{ minHeight: 352, minWidth: 250 }}>
                        <SimpleTreeView>
                            <TreeItem itemId="grid" label="Data Grid">
                                <TreeItem
                                    itemId="grid-community"
                                    label="@mui/x-data-grid"
                                />
                                <TreeItem
                                    itemId="grid-pro"
                                    label="@mui/x-data-grid-pro"
                                />
                                <TreeItem
                                    itemId="grid-premium"
                                    label="@mui/x-data-grid-premium"
                                />
                            </TreeItem>
                            <TreeItem
                                itemId="pickers"
                                label="Date and Time Pickers"
                            >
                                <TreeItem
                                    itemId="pickers-community"
                                    label="@mui/x-date-pickers"
                                />
                                <TreeItem
                                    itemId="pickers-pro"
                                    label="@mui/x-date-pickers-pro"
                                />
                            </TreeItem>
                            <TreeItem itemId="charts" label="Charts">
                                <TreeItem
                                    itemId="charts-community"
                                    label="@mui/x-charts"
                                />
                                <TreeItem
                                    itemId="charts-pro"
                                    label="@mui/x-charts-pro"
                                />
                            </TreeItem>
                            <TreeItem itemId="tree-view" label="Tree View">
                                <TreeItem
                                    itemId="tree-view-community"
                                    label="@mui/x-tree-view"
                                />
                                <TreeItem
                                    itemId="tree-view-pro"
                                    label="@mui/x-tree-view-pro"
                                />
                            </TreeItem>
                        </SimpleTreeView>
                    </Box>
                    <StorageUpload
                        display="Upload File"
                        storageTarget={{
                            type: 'knowledge_base',
                            folder: 'test'
                        }}
                        toasterMessage="Uploading Knowledge: %name%"
                    ></StorageUpload>
                </Flex>
            </div>
        </>
    );
});

export default KnowledgeBase;
